import { RouteConfig } from 'vue-router';
import Settings from '../pages/Settings.vue';

const routes: Array<RouteConfig> = [
  {
    path: '/settings/:section?',
    name: 'settings',
    component: Settings,
    meta: {
      layout: 'full',
      auth: true
    },
  },

];

export default routes;
